import {useRef, useState} from 'react';

import {
  POPUP_STATE_ANIMATION_IN_PROGRESS,
  POPUP_STATE_HIDDEN,
  POPUP_STATE_VISIBLE,
} from '/enum/popupState.enum';

export const usePopupProvider = () => {
  const [modalState, setModalState] = useState(POPUP_STATE_HIDDEN);

  const contentRef = useRef(null);
  const contentPropsRef = useRef(null);
  const interactionPropsRef = useRef(null);

  const showPopup = (
    Component: any,
    componentProps = {},
    interactionProps = {},
  ) => {
    contentRef.current = Component;
    // @ts-expect-error TS(2322): Type '{}' is not assignable to type 'null'.
    contentPropsRef.current = componentProps;
    // @ts-expect-error TS(2322): Type '{}' is not assignable to type 'null'.
    interactionPropsRef.current = interactionProps;

    setModalState(POPUP_STATE_VISIBLE);
  };

  const hidePopup = () => {
    setModalState(POPUP_STATE_ANIMATION_IN_PROGRESS);
  };

  const onAnimationComplete = () => {
    contentRef.current = null;
    contentPropsRef.current = null;
    interactionPropsRef.current = null;

    setModalState(POPUP_STATE_HIDDEN);
  };

  return {
    showPopup,
    interactionPropsRef,
    modalState,
    hidePopup,
    onAnimationComplete,
    contentPropsRef,
    contentRef,
  };
};
